import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const GrandTotal = ({ data, cart, onCheckout }) => {
  const getAmount = (prod) => {
    var result = prod?.reduce(function (acc, obj) {
      return acc + obj.totalPrice;
    }, 0);
    return result;
  };
  return (
    <GrandTotalContainer>
      <GrandTotalSubContainer>
        <SubTotalDiv>
          <SubTotalText>{Text.subTotal}</SubTotalText>
          <SubTotalText>
            {Text.qar} {getAmount(data)}
          </SubTotalText>
        </SubTotalDiv>
        {cart?.discountAmount > 0 && (
          <SavingDiv>
            <SavingText>{Text.saving}</SavingText>
            <SavingText>
              -{Text.qar} {cart?.discountAmount}
            </SavingText>
          </SavingDiv>
        )}
        <GrandTotalDiv>
          <GrandTotalText>{Text.grandTotal}</GrandTotalText>
          <GrandTotalText>
            {Text.qar} {cart?.finalAmount || 0}
          </GrandTotalText>
        </GrandTotalDiv>
      </GrandTotalSubContainer>
      <Line></Line>
      <ContinueButton onClick={() => onCheckout(true)}>
        <ButtonTitle>{Text.proceedToCheckout}</ButtonTitle>
      </ContinueButton>
    </GrandTotalContainer>
  );
};

const GrandTotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Colors.whiteSmoke};
  align-items: center;
  padding-bottom: 1rem
`;
const GrandTotalSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Colors.whiteSmoke};
  padding: 2rem 5rem 0rem 5rem;
  @media only screen and (max-width: 640px) {
    padding: 2rem 2rem 0rem 2rem;
  }
`;
const SubTotalDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1.5rem;
`;
const SavingDiv = styled(SubTotalDiv)``;
const GrandTotalDiv = styled(SubTotalDiv)`
  margin-top: 2rem;
`;

const SubTotalText = styled.span`
  color: ${Colors.arsenic};
  font-size: 1rem;
  font-weight: 500;
`;

const SavingText = styled.span`
  color: ${Colors.parrotGreen};
  font-size: 1rem;
  font-weight: 500;
  margin-top: 0.3rem;
`;

const GrandTotalText = styled(SubTotalText)`
  font-weight: 900;
  text-align: center;
  // border: 1px solid red;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: ${Colors.rainbowGrey};
  margin-top: 2rem;
`;

const ContinueButton = styled.button`
  background: ${Colors.cyan};
  outline: none;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: none;
  margin-top: 2rem;
  cursor: pointer;
`;
const ButtonTitle = styled.span`
  font-size: 1rem;
  font-weight: 900;
  text-align: center;
  color: ${Colors.white};
`;

export default GrandTotal;
